import type { JSONContent } from '@tiptap/react'

const hasNonEmptyText = (node: JSONContent): boolean => {
  if (
    node.type === 'text' &&
    typeof node.text === 'string' &&
    node.text.trim().length > 0
  ) {
    return true
  }
  return (node.content ?? []).some(hasNonEmptyText)
}

export const isTiptapDocEmpty = (
  doc: JSONContent | null | undefined
): boolean => {
  if (!doc) return true
  return !hasNonEmptyText(doc)
}

// ponytail: preview is built from top-level block nodes only (paragraphs,
// headings, tables, list containers) — text within nested list items isn't
// split into separate "lines". Good enough for a 2-line history preview;
// revisit if previews look wrong for deeply nested content.
export const extractPlainTextPreview = (
  doc: JSONContent | null | undefined,
  maxLines = 2
): string => {
  if (!doc?.content) return ''

  const collectText = (node: JSONContent): string => {
    if (node.type === 'text') return node.text ?? ''
    return (node.content ?? []).map(collectText).join('')
  }

  const lines: string[] = []
  for (const block of doc.content) {
    if (lines.length >= maxLines) break
    const text = collectText(block).trim()
    if (text) lines.push(text)
  }

  return lines.join(' — ')
}
